import PipDestinationsView from './PipDestinationsView';
import PipObjectsView from './PipObjectsView';

// PiP 우측 지도 자리에 올릴 정보 레이어 목록(보여주는 순서). 일차에 따라 다른 정보를 보여주려면 레이어를 추가한다.
//
// 새 레이어 추가 방법:
//   1) View 컴포넌트를 만든다. props로 { entries, current }를 받는다(지도를 쓰면 <IslandMap>에 마커를 올려 그린다).
//   2) 아래 목록에 { id, title, isActiveFor, View }를 추가한다. isActiveFor(current)로 보여줄 일차를 정한다
//      (current는 { day, phase } 또는 일차를 모르면 null). 예) isActiveFor: (c) => !!c && c.day >= 5
//   3) 지금 일차에 맞는 레이어가 둘 이상이면 패널에 탭이 생기고, 하나뿐이면 그 레이어가 바로 보인다.

// 1일차 낮이 끝나기 전(일차를 아직 모르는 때 포함)인가.
// 밤으로 읽히면 일차 숫자를 못 읽었어도(day가 null) 어느 밤이든 1일차 밤 이후이므로 false다. 일차를 모르는 낮만 아직 알 수 없어 true다.
const isBeforeFirstNight = (current) => {
  if (!current) {
    return true;
  }
  if (current.phase === 'night') {
    return false;
  }
  return current.day === null || current.day === undefined || current.day === 1;
};

export const MAP_LAYERS = [
  {
    id: 'destinations',
    title: '예상 도착 지역',
    isActiveFor: isBeforeFirstNight, // 게임 시작 전, 1일차 낮까지
    View: PipDestinationsView,
  },
  {
    id: 'objects',
    title: '팀별 오브젝트',
    isActiveFor: (current) => !isBeforeFirstNight(current), // 1일차 밤부터
    View: PipObjectsView,
  },
];
